import {
  FETCH_PROVIDER_CARE_CONVERSATIONS,
  CHAT_LOADER,
  SEND_CARE_MESSAGES,
  FETCH_PATIENT_CARE_MESSAGES,
  ACTIVE_CHAT,
  PROVIDER_SEARCH,
  START_PROVIDER_CHAT,
  SEND_PROVIDER_CONV_MESSAGES,
  FETCH_PROVIDER_TO_PROVIDER_CONVERSATIONS,
  CLEAR_SEARCH,
  PATIENT_CHAT_SEARCH,
  FETCH_PATIENT_CARE_CONVERSATION_OBJ,
  RESET_CHAT_WINDOW
} from './constants';
import { CONNECT_SOCKET } from '../socket/constants';
import { phrApi, phrApiV2 } from '../../api/api';

export function chatLoader() {
  return { type: CHAT_LOADER };
}

export function connectSocket() {
  return { type: CONNECT_SOCKET };
}

export function activeChat(patientId, careConversationId, patientDetails) {
  return {
    type: ACTIVE_CHAT,
    payload: { patientDetails, patientId, careConversationId }
  };
}

export function fetchPatientCareConversationObj(patientId) {
  const careConvObj = phrApiV2(
    'get',
    `care_conversation/patient/${patientId}`,
    null
  );

  return dispatch => {
    dispatch(chatLoader());
    careConvObj.then(response =>
      dispatch({
        type: FETCH_PATIENT_CARE_CONVERSATION_OBJ,
        payload: response
      }).catch(error => console.log(error))
    );
  };
}
export function sendCareMessage(messageObj) {
  return {
    type: SEND_CARE_MESSAGES,
    payload: messageObj,
    socket: {
      namespace: 'careConversation',
      channel: 'message'
    }
  };
}

export function sendProviderConvMessages(messageObj) {
  return {
    type: SEND_PROVIDER_CONV_MESSAGES,
    payload: messageObj,
    socket: {
      namespace: 'conversation',
      channel: 'message'
    }
  };
}

export function fetchProviderCareConversations() {
  const conversations = phrApiV2('get', 'care_conversation', null);
  return dispatch => {
    dispatch(chatLoader());
    conversations
      .then(response =>
        dispatch({ type: FETCH_PROVIDER_CARE_CONVERSATIONS, payload: response })
      )
      .catch(error => console.log(error.response));
  };
}

export function fetchCareMessages(careConversationId) {
  const messages = phrApiV2(
    'get',
    `message/care_conversation/${careConversationId}`,
    null
  );
  return dispatch => {
    dispatch(chatLoader());
    messages
      .then(response =>
        dispatch({
          type: FETCH_PATIENT_CARE_MESSAGES,
          payload: response
        })
      )
      .catch(error => console.log(error.response));
  };
}

export function providerSearch(searchTerm) {
  const results = phrApi('get', 'conversation/user_detail', null, {
    name: searchTerm
  });
  return dispatch => {
    results
      .then(response => dispatch({ type: PROVIDER_SEARCH, payload: response }))
      .catch(error => console.log(error.response));
  };
}

export function startProviderChat(providerId, providerDetails) {
  return {
    type: START_PROVIDER_CHAT,
    payload: { providerId, providerDetails }
  };
}

export function fetchProviderToProviderConversations() {
  const conversations = phrApi('get', 'conversation', null);
  return dispatch => {
    dispatch(chatLoader());
    conversations
      .then(response =>
        dispatch({
          type: FETCH_PROVIDER_TO_PROVIDER_CONVERSATIONS,
          payload: response
        })
      )
      .catch(error => {
        throw new Error('Fetch Provider to Provider API not working.');
      });
  };
}

export function clearSearch() {
  return { type: CLEAR_SEARCH };
}

export function patientChatSearch(searchTerm) {
  return { type: PATIENT_CHAT_SEARCH, payload: searchTerm };
}

export function resetChatWindow() {
  return { type: RESET_CHAT_WINDOW };
}


